import { render } from "./HomeView_MS.vue?vue&type=template&id=6da21cab"
import script from "./HomeView_MS.vue?vue&type=script&lang=js"
export * from "./HomeView_MS.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__